import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { submitReflection } from "@/lib/api";
import { toast } from "sonner";
import { useT } from "@/lib/i18n";

export default function ReflectionStep({ attempt, onAdvance }) {
  const { t } = useT();
  const concept = attempt.current_concept;
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (text.trim().length < 30) {
      toast.error(t("step.reflection_too_short"));
      return;
    }
    setBusy(true);
    try {
      await submitReflection(attempt.id, { concept_id: concept.id, text });
      await onAdvance();
    } catch (e) {
      toast.error(e?.response?.data?.detail || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 pb-24" data-testid="reflection-step">
      <div className="paper p-6 md:p-8">
        <div className="label-mono">{t("step.reflection_layer")}</div>
        <h2 className="font-display text-2xl font-bold mt-1">{t("step.reflection_title")}</h2>
        <p className="text-sm text-[var(--iddl-muted)] mt-2">{t("step.reflection_sub")}</p>

        <div className="mt-6 paper p-4 surface border border-[var(--iddl-rule)]">
          <div className="label-mono">{t("step.reflection_prompt")}</div>
          <p className="font-display text-base mt-1">{concept.reflection.prompt}</p>
        </div>

        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={9}
          className="mt-4 rounded-none border-[var(--iddl-rule)] focus-visible:ring-0 focus-visible:border-[var(--iddl-ink)]"
          placeholder={t("step.reflection_placeholder")}
          data-testid="reflection-textarea"
        />

        <div className="mt-6">
          <Button onClick={submit} disabled={busy} data-testid="btn-submit-reflection" className="btn-ink rounded-none h-11 px-6">
            {busy ? t("step.reflection_submitting") : t("step.reflection_submit")}
            <ArrowRight size={14} className="ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
}
